<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            class="teacher-invite"
            :items="allTeachers"
            :show-empty="true"
            :fields="fields">
            <template v-slot:options>
                <b-button
                    class="btn-upload btn-assignment-import-list"
                    v-if="isAdmin"
                    variant="primary"
                    @click="importList">
                    {{ $t('group_pair.import_list') }}
                </b-button>

                <b-button
                    class="btn-add btn-add-teacher"
                    v-b-modal="'group-pair-add-teacher-modal'"
                    variant="primary">
                    {{ $t('group_pair.add_teachers') }}
                </b-button>

                <design-2021-group-pair-index-add-teacher-modal
                    :group-id-in="groupIdIn"
                    @add-teachers="addTeachers">
                </design-2021-group-pair-index-add-teacher-modal>
            </template>

            <template v-slot:cell(actions)="data">
                <div class="actions">
                    <b-button
                        class="btn-edit btn-edit-teacher-group-piar remove-icon-margin"
                        v-b-modal="'group-pair-edit-teacher-modal' + data.item.id"
                        v-b-tooltip.hover
                        variant="primary-icon-only"
                        :title="$t('group_pair.edit_teacher')">
                    </b-button>

                    <design-2021-group-pair-index-edit-teacher-modal
                        :teacher-in="data.item"
                        @update-teacher="updateTeacher">
                    </design-2021-group-pair-index-edit-teacher-modal>

                    <b-button
                        class="btn-remove btn-remove-teacher-group-pair remove-icon-margin"
                        v-b-tooltip.hover
                        variant="danger-icon-only"
                        :title="$t('group_pair.delete_teacher')"
                        @click="remove(data.item)">
                    </b-button>
                </div>
            </template>

            <template #empty="scope">
                <div class="not-found">
                    <div class="icon">
                        <i class="fas fa-exclamation-circle"></i>
                    </div>
                    <div class="alert-notice group-admin-message">{{ $t('group_pair.no_teachers_found') }}</div>
                </div>
            </template>
        </design-2021-apprentice-data-table>
    </div>
</template>

<script>
import { ords } from '../../../app';

export default {
    name: 'design-2021-group-pair-index-teacher-component',
    props: ['groupIdIn', 'checkOption'],
    data() {
        return {
            teachers: [],
            fields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                    sortable: true,
                },
                {
                    key: 'email',
                    label: this.$t('common.email_address'),
                    sortable: true,
                },
                {
                    key: 'requests',
                    label: this.$t('group_pair.requests'),
                    sortable: true,
                },
                {
                    key: 'subs',
                    label: this.$t('group_pair.groups'),
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            isAdmin: !!AuthIsAdmin,
        };
    },
    mounted() {
        //op dit moment gaan we er van uit dat dit component maar 1 group_id heeft ->in engels
        ords.use('group_pair_teachers')
            .with('user', (userCallback) => {
                userCallback.with('group_pair_group_teachers', (groupPairGroupTeachersCallback) => {
                    groupPairGroupTeachersCallback.with('group_pair_groups');
                    groupPairGroupTeachersCallback.whereHas('group_pair_groups');
                });
            })
            .get()
            .subscribe((teachers) => {
                this.teachers = teachers;
            });
    },
    methods: {
        remove(teacherData) {
            const currentTeacher = this.teachers.filter((teacher) => teacher.id === teacherData.id);
            const text = currentTeacher[0].user.group_pair_group_teachers.length
                ? this.$t(
                      'group_pair.are_you_sure_you_want_to_unlink_this_teacher_this_teacher_has_been_chosen_by_one_or_more_groups',
                  )
                : this.$t('group_pair.are_you_sure_you_want_to_unlink_this_teacher');

            this.alert.confirm(null, text, this.$t('group_pair.yes_unlink')).then((confirm) => {
                if (!confirm) {
                    return;
                }

                this.alert.saving();

                this.axios.delete(this.routes.groupPairTeacherDelete(currentTeacher[0].id)).then(
                    (response) => {
                        ords.hold();
                        currentTeacher[0].detach('user', currentTeacher[0].user);
                        currentTeacher[0].remove();
                        ords.continue();
                        this.alert.success();
                    },
                    (error) => {
                        this.alert.ajaxError(error);
                    },
                );
            });
        },

        importList() {
            window.location.href = this.routes.groupPairTeacherImport(this.groupIdIn);
        },

        updateTeacher(teacherData) {
            const currentTeacher = this.teachers.filter((teacher) => teacher.id === teacherData.id);
            currentTeacher[0].update(teacherData);
        },

        addTeachers(teachers) {
            this.teachers = [...teachers];
        },
    },

    computed: {
        allTeachers() {
            if (this.teachers.length === 0) {
                return [];
            }

            return this.teachers.map((teacher) => {
                return {
                    id: teacher.id,
                    name: teacher.user.full_name,
                    max: teacher.max,
                    email: teacher.user.email,
                    requests: teacher.user.groupPairGroupTeacherOpenRequestsCount(this.checkOption),
                    subs: teacher.max
                        ? `${teacher.user.groupPairGroupTeacherConfirmedGroupCount(this.checkOption)} / ${teacher.max}`
                        : teacher.user.groupPairGroupTeacherConfirmedGroupCount(this.checkOption),
                };
            });
        },
    },

    watch: {
        teachers: function (value) {
            this.teachers = value;
        },
    },
};
</script>

<style scoped lang="scss">
.actions {
    display: flex;

    .btn:not(:last-child) {
        margin-right: map-get($grid-gutter-spacing, 'eight');
    }
}

.teacher-invite ::v-deep {
    .apprentice-table-header {
        .options {
            column-gap: map-get($grid-gutter-spacing, 'fifteen');
        }
    }
}
</style>
